export default {
  notificationSound: "https://s3.amazonaws.com/campayn/static/audio/kiosk.mp3",
  presets: {
    default: { stiffness: 330, damping: 20 },
  }
}
